/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Undo Redo Buttons",
  "description": "Adds undo and redo buttons so it is easier to undo and redo in the code editor",
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "undo-redo-buttons.css"
    }
  ],
  "tags": [
    "beta",
    "dm",
    "new"
  ],
  "enabledByDefault": true
};
export default manifest;
